export default __webpack_public_path__ + "static/payhere-8b41fb6b94c2dc14418a41733cd3028b.jpeg";